// extracted by mini-css-extract-plugin
export default {"cell":"HistoryEventTypeCell-cell-Q8TMw TableRowCell-cell-giPrj"};